import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    TextHeader,
    createTextHeader,
} from '@vfde-brix/ws10/text-header';
import {
    ADDITIONAL_PAGE_OPTIONS,
    SALESCHANNEL_REDPLUS,
    SALESCHANNEL_SOHO,
} from '@vfde-sails/constants';
import { replacePlaceholders } from '@vfde-sails/utils';
import { startAppListening } from '../../../app/listener';
import {
    selectAtomicDevice,
    selectTariff,
    selectDevice,
} from '../selectors';
import { selectCustomerConfig } from '../slice';
import { RootState } from '../../../app/store';

/**
 * Mount TextHeader
 */
export const mountTextHeader = (containerId: string): TextHeader | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const textHeader = createTextHeader(container, NO_PATTERN_BUSINESS_LOGIC);

    listenForUpdates(textHeader);

    return textHeader;
};

const listenForUpdates = (textHeader: TextHeader) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectAtomicDevice(currentState) !== selectAtomicDevice(previousState)
            || selectTariff(currentState) !== selectTariff(previousState)
            || selectCustomerConfig(currentState).isHardwareOnly !== selectCustomerConfig(previousState).isHardwareOnly
        ,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            updateTextHeader(textHeader, state);
        },
    });
};

/**
 * Update headline
 */
const updateTextHeader = (textHeader: TextHeader, state: RootState): void => {
    const subscription = selectTariff(state);
    const customerConfig = selectCustomerConfig(state);
    const device = selectDevice(state);
    const { isHardwareOnly, salesChannel } = customerConfig;

    const {
        hardwareOnly,
        soho,
        redplus,
        headline,
        subline,
    } = window[ADDITIONAL_PAGE_OPTIONS];

    let headlineSuffix = headline;
    let sublineSuffix = subline;
    let stdSubline: string | undefined;

    if (subscription && !isHardwareOnly) {
        const { tariffName } = subscription;

        if (salesChannel === SALESCHANNEL_SOHO) {
            sublineSuffix = soho.subline;
        }

        stdSubline = replacePlaceholders(sublineSuffix, { tariffName });
    }

    switch (true) {
        case isHardwareOnly:
            headlineSuffix = hardwareOnly.headline;
            break;
        case salesChannel === SALESCHANNEL_REDPLUS:
            headlineSuffix = redplus.headline;
            break;
    }

    textHeader.update({
        ...device?.modelName && { stdHeadline: `${device.modelName} ${headlineSuffix}` },
        stdSubline,
    });
};
